import { render } from "./Location.vue?vue&type=template&id=6059cec9&scoped=true"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"

import "./Location.vue?vue&type=style&index=0&id=6059cec9&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/bmu-website/bmu-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6059cec9"]])

export default __exports__